import { atom } from "recoil"
import { HealthState } from '../../types/health'

const streamingHealthAtom = atom<HealthState | null>({
  key: "streamingHealthAtom",
  default: null
})

export default streamingHealthAtom;
